import styled from 'styled-components';
import backgroundNavigation from '../../assets/home/darkblue-footer-background.png';
import background from '../../assets/home/background-vinograd.jpg';

export const Navigation = styled.div`
    z-index: 1000;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
    padding: 0 60px;
    background: ${(props) => (props.single === true) ? `url(${backgroundNavigation})` : 'transparent'};
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1200px) {
        padding: 0 40px;
    }

    @media (max-width: 800px) {
        padding: 0 20px;
    }
`;

export const HeaderItemWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
`;

export const HeaderItem = styled.p`
    color: white;
    margin: 0 10px;
    text-transform: uppercase;
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Img = styled.img`
    width: ${(props) => props.small ? '35px' : '150px'}
`;

export const MobileMenuBar = styled.img`
    width: 40px;
`;

export const MobileMenuContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: ${(props) => props.isOpenMobileMenu === true ? '100vh' : '0'};
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transition: all .5s;
    -webkit-transition: all .5s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: ${(props) => props.isOpenMobileMenu === true ? '100px' : '0'};
`;

export const HeaderListItemWrapper = styled.div`
    height: 60px;
    width: 100vw;
    transition: all .5s;
    display: flex;
    align-items: center;
    justify-content: center;
`;